import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of, Subject, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { APP_CONFIG } from 'src/app/configs/app-config.constants';
import { InterfaceAppConfig } from 'src/app/configs/app-interface.config';

@Injectable({
    providedIn: 'root',
})
export class MKSService {
    private apiUrl;
    domainUrl = environment.apiurl;
    gyanDomainUrl = environment.gyanApiUrl;

    constructor(
        private http: HttpClient,
        @Inject(APP_CONFIG)
        private config: InterfaceAppConfig,
    ) {
        this.apiUrl = environment.gyanApiUrl + 'admin/v1';
    }

    getMKSList(): Observable<any> {
        return this.http.get(`${this.apiUrl}/mks/site`);
    }

    getSiteRole(): Observable<any> {
        return this.http.get(`${this.apiUrl}/mks/site-roles`);
    }

    getUsergroup(usergroupData: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/user-groups`, usergroupData);
    }
    getSiteVisibility() {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const url = this.gyanDomainUrl + this.config.apis.admin.siteVisibility;
        return this.http.get(url, { headers: headers });
    }
    createandupdateSite(req: any) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const url = this.gyanDomainUrl + this.config.apis.admin.createAndUpdateSite;
        return this.http.post(url, req, { headers: headers });
    }

    getUserGroupsBySiteId(req: any) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const url = this.gyanDomainUrl + this.config.apis.admin.usergroupListMKS;
        return this.http.post(url, req, { headers: headers });
    }

    getSiteRoles() {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const url = this.gyanDomainUrl + this.config.apis.admin.siteRole;
        return this.http.get(url, { headers: headers });
    }

    getUserupdate(userupdateData: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/mks/users`, userupdateData);
    }

    getClientName(userList: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/client-list`, userList);
    }

    deleteUser(siteId: string, userId: number): Observable<any> {
        return this.http.delete(`${this.apiUrl}/mks/user/${siteId}/${userId}`);
    }

    UpdateUser(updateuser: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/mks/add-update-user`, updateuser);
        // /admin/v1/mks/add-update-user
    }

    UpdateUserGroup(updateuserGroups: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/mks/add-update-user-groups`, updateuserGroups);
    }

    deleteUserGroups(siteId: string, userGroup: string): Observable<any> {
        return this.http.delete(`${this.apiUrl}/mks/user-group/${siteId}/${userGroup}`);
    }
}
